import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import FeaturedOrgBannerCard from './FeaturedOrgBannerCard';
import  Slider  from 'react-slick';
//import isLoggedIn from '../../utils'



export default class HomeBannerSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    if (this.refs.slider) {
      this.refs.slider.innerSlider.autoPlay();
    }
  }

  render() {
    let auth = this.props.auth;
    let browser = this.props.browser;

    let settings = {};

    if (browser.greaterThan.desktop) {
      settings = {
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: true
      };
    } else {
      settings = {
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000
      };
    }


    let homeBannerOrgs = '';
    homeBannerOrgs = this.props.homeBannerOrgs;

    let homeBannerOrgList = '';

    if (!this.props.homeBannerOrgs.isLoaded) {
      return <span />
    }

    let CTA = '';

    if ((auth.user === null)) {
      CTA = <div className="homeBannerFeaturedOrgs-ctaInnerWrapper">
        <div className="homeBannerFeaturedOrgs-cta">
          <div className="homeBannerFeaturedOrgs-ctaHeader">Global Resource Directory</div>
          <div className="homeBannerFeaturedOrgs-ctaCopy">
            The central place where women come to connect with resources that help them thrive
          </div>
          <div className="homeBannerFeaturedOrgs-ctaBtnWrapper">
            <div className="btnWrapper join">
              <button onClick={(e) => {e.preventDefault(); this.props.openSignupFormRequest() }}
                className="homeBannerFeaturedOrgs-btn button button-wrap">Sign up (it's free)</button>
            </div>
          </div>
        </div>
      </div>
    }




    let slideCount = homeBannerOrgs.length;

    homeBannerOrgList = homeBannerOrgs.map((org, index) => {
      return <div data-slideindex={`slide-${index}`} key={`slide-${index}`}>
        <FeaturedOrgBannerCard
          name = {org.name}
          description = {org.description}
          orgImgUrl = {org.image_home_slider_banner}
          rootCategories = {org.root_category}
          rootRegions = {org.root_region}
          orgId = {org.db_id}
          index = {index}
          slideCount = {slideCount}
          setParentSlideInfo = {this.setParentSlideInfo}
        />
      </div>
    });

    return(
      <main>
        <div  className="homeBannerFeaturedOrgs-wrapper">
          
          <Slider ref="slider" { ...settings }>{homeBannerOrgList}</Slider>
        </div>
      </main>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/homeBanner/HomeBannerSlider.jsx